import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Button,
  Link as MuiLink,
} from "@mui/material"
import { FileText, CheckCircle, Clock, ArrowRight } from "lucide-react"

import { NavLink } from "react-router-dom"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
const textColor = "#0d2561"
const itextColor = "#707070"

export default function MyRFPsStatusWidget() {
  const data = {
    listedRFPs: 10,
    fulfilledRFPs: 7,
    pendingRFPs: 3,
  }

  return (
    <Card>
      
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1,fontSize:'1.20rem' }}>
          My RFPs Status
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Number of RFPs listed by user, how many fulfilled, and pending.
        </Typography>
        <Box mt={2} display="flex" flexDirection="column" gap={2}>
          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <FileText  style={{width:'20px',height:'20px'}}/>              
              <Typography sx={{ color: textColor,fontSize:'18px',fontWeight:'bold' }}>
                {data.listedRFPs}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              RFPs Listed
            </Typography>
          </Box>

          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <CheckCircle style={{width:'20px',height:'20px',color: "#16a34a",fontWeight:600}} />             
              <Typography variant="h6" sx={{ color: "#16a34a",fontSize:'18px',fontWeight:'bold'  }}>
                {data.fulfilledRFPs}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              RFPs Fulfilled
            </Typography>
          </Box>

          <Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Clock style={{width:'20px',height:'20px',color: "#f97316",fontWeight:600}} />              
              <Typography variant="h6" sx={{ color: "#f97316",fontSize:'18px',fontWeight:'bold' }}>
                {data.pendingRFPs}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" ml={5}>
              RFPs Pending
            </Typography>
          </Box>
        </Box>
        <Box textAlign="right" mt={9}>
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                p: 0,
                minHeight: "auto",
                color: textColor
              }}
            >
                View all RFP statuses
            </Button>
          </NavLink>
        </Box>

      </CardContent>
    </Card>
  )
}
